import React from 'react';
import { messages } from '../../../messages';
import { dateFormatter } from '../utils/date-formatter';
export const getTimeDetailForJiraIssueResult = (intl, formatDate, updated) => {
  if (!updated) {
    const message = intl.formatMessage(messages.common_recently_viewed_section_heading);
    return /*#__PURE__*/React.createElement("span", {
      title: message
    }, message);
  }
  if (formatDate) {
    return formatDate(updated);
  } else {
    return dateFormatter(updated);
  }
};